import styled from "styled-components";
const FooterWarper = styled.div`
    width: 100%;
    height: 50px;
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8em;
    color: #737373;
    font-weight: bold;
    margin-top: 1rem;
`;

export { FooterWarper };
